var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L14 17",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L10 17",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6V5.2C5.55817 5.2 5.2 5.55817 5.2 6H6ZM18 6H18.8C18.8 5.55817 18.4418 5.2 18 5.2V6ZM6 6.8H18V5.2H6V6.8ZM17.2 6V20H18.8V6H17.2ZM17 20.2H7V21.8H17V20.2ZM6.8 20V6H5.2V20H6.8ZM7 20.2C6.88954 20.2 6.8 20.1105 6.8 20H5.2C5.2 20.9941 6.00589 21.8 7 21.8V20.2ZM17.2 20C17.2 20.1105 17.1105 20.2 17 20.2V21.8C17.9941 21.8 18.8 20.9941 18.8 20H17.2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H20",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6V6.8C16.4418 6.8 16.8 6.44183 16.8 6H16ZM8 6H7.2C7.2 6.44183 7.55817 6.8 8 6.8V6ZM9 3.8H15V2.2H9V3.8ZM15.2 4V6H16.8V4H15.2ZM16 5.2H8V6.8H16V5.2ZM8.8 6V4H7.2V6H8.8ZM15 3.8C15.1105 3.8 15.2 3.88954 15.2 4H16.8C16.8 3.00589 15.9941 2.2 15 2.2V3.8ZM9 2.2C8.00589 2.2 7.2 3.00589 7.2 4H8.8C8.8 3.88954 8.88954 3.8 9 3.8V2.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.af09e3bc1eb15cf04372695cb33e43e6.svg";
export { ForwardRef as ReactComponent };